import type { BoardSnapshot, Item } from "../types";

// Horizontal timeline derived from each item's timeline column (from/to).
export function GanttView({ snap }: { snap: BoardSnapshot }) {
  const tlCol = snap.columns.find((c) => c.type === "timeline");
  const rows = snap.items
    .map((it) => {
      const v = tlCol ? it.cells[tlCol.id] : null;
      if (v && typeof v === "object" && "from" in v && v.from && v.to)
        return { it, from: new Date(v.from), to: new Date(v.to) };
      return null;
    })
    .filter(Boolean) as Array<{ it: Item; from: Date; to: Date }>;

  if (!tlCol || !rows.length)
    return <div className="board-scroll"><p className="muted">Keine Timeline-Daten vorhanden.</p></div>;

  const min = Math.min(...rows.map((r) => +r.from));
  const max = Math.max(...rows.map((r) => +r.to));
  const span = Math.max(max - min, 1);
  const pct = (t: number) => ((t - min) / span) * 100;

  // Month gridlines.
  const months: { label: string; left: number }[] = [];
  const d = new Date(min); d.setDate(1);
  while (+d <= max) {
    months.push({ label: d.toLocaleDateString("de-DE", { month: "short", year: "2-digit" }), left: pct(+d) });
    d.setMonth(d.getMonth() + 1);
  }

  return (
    <div className="gantt board-scroll">
      <div className="gantt-row" style={{ height: 22 }}>
        <div className="gantt-label" />
        <div className="gantt-track" style={{ background: "transparent" }}>
          {months.map((m, i) => (
            <span key={i} style={{ position: "absolute", left: `${m.left}%`, fontSize: 11, color: "var(--text-faint)" }}>{m.label}</span>
          ))}
        </div>
      </div>
      {rows.sort((a, b) => +a.from - +b.from).map(({ it, from, to }) => (
        <div className="gantt-row" key={it.id}>
          <div className="gantt-label" title={it.name}>{it.name}</div>
          <div className="gantt-track">
            <div className="gantt-bar" style={{ left: `${pct(+from)}%`, width: `${Math.max(pct(+to) - pct(+from), 1)}%` }}
              title={`${from.toLocaleDateString("de-DE")} – ${to.toLocaleDateString("de-DE")}`} />
          </div>
        </div>
      ))}
    </div>
  );
}
